<script>
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher } from "svelte";
    import Fa from "svelte-fa";
    import Button from "../ui/Button.svelte";
    import ButtonAdd from "../ui/ButtonAdd.svelte";
    import TextInput from "../ui/TextInput.svelte";
    import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
    import { faAdd, faClose, faEdit, faPen, faX } from "@fortawesome/free-solid-svg-icons";

    const dispatch = createEventDispatcher();

    export let mode;
    export let platform = "Unbekannt";
    export let key = "test";
    export let path;
    export let value;
    let value_internal = value;

    function confirm() {
        trim();
        dispatch("add", {key, value: value_internal});
        open = false;
    }

    function remove() {
        value_internal = undefined;
        dispatch("remove", {key});
    }

    function cancel() {
        value_internal = value;
        open = false;
    }

    function trim() {
        console.log("value_internal");
        value_internal = value_internal.trim();
        // extract handle from url
        const split = value_internal.split(path);
        value_internal = split[split.length - 1];
        // remove trailign slash
        value_internal = value_internal.endsWith('/') ? value_internal.slice(0, -1) : value_internal;
    }

    let open = false;
</script>

<Dialog class="dialog" open={open} on:close={cancel}>
    <DialogOverlay class="dialog-overlay"/>
    <div class="dialog-content">
        <DialogTitle class="dialog-title">{platform} verlinken</DialogTitle>
        <DialogDescription class="dialog-description">
            Füge deinen {platform} Handle hinzu. Dieser wird dann auf deinem Profil angezeigt.
        </DialogDescription>
        
        <form on:submit|preventDefault={confirm}>
            <TextInput
                label={path}
                bind:value={value_internal}
                on:blur={trim}
            />
            
            <div class="dialog-options">
                <Button type="button" on:click={cancel}>
                    Abbrechen
                </Button>
                <Button type="submit" intent="primary">
                    Bestätigen
                </Button>
            </div>
        </form>
    </div>
</Dialog>

<div class="social" class:active={value} class:edit={mode === "edit"} class:view={mode === "view"}>
    <div class="left">
        {#if key === "instagram"}
            <Fa
                icon={faInstagram}
            />
        {:else if key === "facebook"}
            <Fa
                icon={faFacebook}
            />
        {/if}
        {#if value}
            {path}{value}
        {:else}
            {platform} nicht verlinkt
        {/if}
    </div>
    {#if mode === "edit"}
        <div class="actions">
            {#if value}
                <Button on:click={() => {open = true}}>
                    <Fa
                        icon={faPen}
                        slot="icon"
                    />
                </Button>
                <Button on:click={() => {remove(key)}}>
                    <Fa
                    icon={faClose}
                    slot="icon"
                    />
                </Button>
            {:else}
                <Button on:click={() => {open = true}}>
                    <Fa
                        icon={faAdd}
                        slot="icon"
                    />
                </Button>
            {/if}
        </div>
    {/if}
</div>

<style>
    .social {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 1rem;
        background-color: white;
        padding: 0.75rem 1rem;
    }
    
    .social:not(.active) {
        background-color: #faf9f7;
    }

    .social:not(.active) .left{
        opacity: 0.5;
    }
    
    .left {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 1rem;
    }

    .actions{
        margin: -0.75rem;
    }
</style>
